export const OWNER_ROLE = 10;
export const BESPO_AGENCY_CODE = 'bespo';
export const TYPE_CREDIT = 1;